import * as React from "react";

import axios from "axios";

import { useNavigate, Link } from "react-router-dom";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";

import {
  RiArrowLeftLine,
  RiPhoneLine,
  RiMapPin2Line,
  RiMailLine,
} from "react-icons/ri";

import Button from "../../Components/Button";

import Logo from "./../../Images/logo.png";
import { useLoader } from "../../Context/LoaderContext";
import { useToast } from "../../Context/ToastContext";

import { statusFinancing } from "../../Functions/satus_financing_request";
import { wrapStatusFinancing } from "../../Functions/wrap_satus_financing_request";

import "./DetailsFinancingRequestNotConnected.scss";

const DetailsFinancingRequestNotConnected = () => {
  const [dataSimulation, setDataSimulation] = React.useState({});

  const navigate = useNavigate();
  const { addToast } = useToast();

  const { setIsLoading } = useLoader();

  React.useEffect(() => {
    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/get-request-with-simulation`, {
        headers: {
          Accept: "application/json",
          "Content-Type": "multipart/form-data",
          "Access-Token": localStorage.getItem(
            process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE_REQUEST
          ),
        },
      })
      .then((response) => {
        setIsLoading(false);
        setDataSimulation(response.data?.data || []);
      })
      .catch((error) => {
        setIsLoading(false);

        addToast({
          variant: "danger",
          message: error.response.data.data.message,
        });
      });
  }, [addToast, setIsLoading]);

  const handleLogout = () => {
    navigate("/");
    localStorage.removeItem(
      process.env.REACT_APP_LOCAL_STORAGE_KEY_TOKEN_OFFLINE_REQUEST
    );
  };

  return (
    <div className="layout-app layout-app-details-request">
      <div className="sideBar sideBar-details-request">
        <div className="title-sidebar-not-connected active">
          <Button variant="dark" type="submit" onClick={handleLogout}>
            <RiArrowLeftLine />
            Retour vers la page d'accueil
          </Button>
        </div>
      </div>
      <div className="wrap-app wrap-app-not-connected justify-content-center flex-direction-row">
        <div className="container-app container-app-not-connected">
          <div className="wrap-confirm-request text-left">
            <Link to="/" className="logo">
              <img
                src={Logo}
                alt="Attijari Leasing Tunisie, Crédit Leasing Tunisie | Attijari"
              />
            </Link>
            <div className="title-confirm-request text-left mb-40 mt-32">
              Détails de votre Demande <br /> de Financement Leasing
            </div>

            <Row className="mb-64">
              <Col md={12} className="mb-24">
                <div className="box-folder-number">
                  <div className="title-folder-number">Numéro de Dossier</div>
                  <div className="folder-number">
                    {dataSimulation.reference}
                  </div>
                </div>
              </Col>
              <Col md={12}>
                <div className={wrapStatusFinancing(dataSimulation?.status)}>
                  <div className="title-details-financement">
                    {statusFinancing(
                      dataSimulation.status,
                      dataSimulation.status_text
                    )}
                  </div>
                  <div
                    className="content-details-financement bold"
                    dangerouslySetInnerHTML={{
                      __html: dataSimulation?.status_description,
                    }}
                  />
                  {/* <div className="sub-title-details-financement">
                  Merci de votre patience.
                </div> */}
                </div>
              </Col>
            </Row>

            <Row>
              <Col md={6}>
                <div className="box-confiance">
                  <div className="title-confiance">
                    Merci de votre confiance
                  </div>
                  <div className="content-details-financement">
                    Si vous avez des questions <br />
                    ou des préoccupations, n'hésitez pas à <br />
                    contacter notre service client
                  </div>
                </div>
              </Col>
              <Col md={6}>
                <div className="wrap-adress-demande wrap-adress-financement">
                  <div className="box-adress-demande">
                    <div className="icon-adress-demande">
                      <RiPhoneLine />
                    </div>
                    <div className="content-adress-demande">
                      <div className="title-adress-demande">Appelez nous</div>
                      <div className="caption-adress-demande">
                        (+216) 70 136 436 <br />
                        (+216) 39 140 836
                      </div>
                    </div>
                  </div>
                  <div className="box-adress-demande">
                    <div className="icon-adress-demande">
                      <RiMailLine />
                    </div>
                    <div className="content-adress-demande">
                      <div className="title-adress-demande">Adresse email </div>
                      <div className="caption-adress-demande">
                        <a href="mailto:service.client@attijarileasing.com.tn">
                          service.client@attijarileasing.com.tn
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetailsFinancingRequestNotConnected;
